"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RelationStatus = exports.DataStatus = void 0;
var DataStatus = Object.freeze({
  ADD: 'add',
  EDIT: 'edit',
  DELETE: 'delete'
});
exports.DataStatus = DataStatus;
var RelationStatus = Object.freeze({
  LEFT: 'left',
  // 普通关联，关联键值在左边(父节点)数据
  RIGHT: 'right',
  // 普通关联，关联键值在右边(子节点)数据
  INCLUDE: 'include',
  // link关联，关联键值在左边(父节点)数据
  IN: 'in' // link关联，关联键值在右边(子节点)数据
});
exports.RelationStatus = RelationStatus;